module.exports = __webpack_public_path__ + "img/Screenshot-6.5c1082fa.png";